export default __webpack_public_path__ + "62a8af87ff09872cabfeda35e333b943.png";